import { SelectOptionTypes } from "../../../../components/Input";
import { toIsoDate } from "../../../../utils/dates";
import { AmountVariant } from "../../../../utils/tone";
import { PanelAction } from "../../types";
import { TransactionTypeOptions } from "./types";

export const FORM_ID = "transactions";

export const SUBMIT_LABELS: Record<PanelAction, string> = {
  create: "Create transaction",
  edit: "Save changes",
  duplicate: "Create copy",
};

export const MOBILE_SUBMIT_LABELS: Record<PanelAction, string> = {
  create: "Create",
  edit: "Save",
  duplicate: "Create",
};

export const TYPE_OPTIONS = [
  { label: "Expense", value: TransactionTypeOptions.EXPENSE },
  { label: "Income", value: TransactionTypeOptions.INCOME },
  { label: "Transfer", value: TransactionTypeOptions.TRANSFER },
  { label: "Loan Payment", value: TransactionTypeOptions.LOAN_PAYMENT },
] as SelectOptionTypes[];

export const SEGMENT_LABELS: Record<string, string> = {
  [TransactionTypeOptions.LOAN_PAYMENT]: "Loan",
};

export const TONE_BY_TYPE: Record<string, AmountVariant> = {
  [TransactionTypeOptions.EXPENSE]: "expense",
  [TransactionTypeOptions.LOAN_PAYMENT]: "expense",
  [TransactionTypeOptions.INCOME]: "income",
  [TransactionTypeOptions.TRANSFER]: "neutral",
};

export const createDefaultTransaction = () => ({
  fromAccount: null,
  toAccount: null,
  amount: "",
  taxWithheld: "",
  transactionType: TYPE_OPTIONS[0],
  note: "",
  transactionDate: toIsoDate(new Date()),
  principalAmount: "",
  interestAmount: 0,
  categoryId: 0,
  subCategoryId: 0,
  isRecurring: false,
  frequency: null,
  interval: undefined,
  stopAfterOccurrences: undefined,
});

export const CASHBACK_EARNED_RULES = {
  min: { value: 0, message: "Earned cashback cannot be negative" },
};

export const CASHBACK_EARNED_HELPER =
  "Added to this account's balance with the expense — don't also add it as an income. Suggested from the rate and monthly cap.";

export const OLDER_CASHBACK_EARNED_HELPER =
  "Recorded before cashback was added to the balance, so it stays a note and doesn't change this account's balance.";

export const CASHBACK_LOADING_MESSAGE = "Loading cashback…";
